module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aJY0L"))).then(() => module.bundle.root('1iHdE'));